import type { ReactNode } from 'react';

type Tone = 'error' | 'success' | 'info';

const toneClass: Record<Tone, string> = {
  error: 'bg-negative-soft text-negative',
  success: 'bg-positive-soft text-positive',
  info: 'bg-accent-soft text-accent-ink',
};

export const Banner = ({ tone, children }: { tone: Tone; children: ReactNode }) => (
  <div className={`rounded-md p-4 ${toneClass[tone]}`} role={tone === 'error' ? 'alert' : 'status'}>
    <div className="text-sm">{children}</div>
  </div>
);
